import { useStoreState } from 'easy-peasy';
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import axios from '../../services/axios';
import ActivitiesCard from './ActivitiesCard.jsx';

import './ActivitiesPanel.scss';

const ActivitiesPanel = () => {
    const [activity, setactivity] = useState(0);

    const updatingInterval = 1000 * 60; // in milliseconds

    const { apiData :{URLs}} = useStoreState(state => state.actionSlugs);

    const getUrl = URLs?.getActivity?.url;

    const updateData = () => {
        axios.get(getUrl)
            .then((response) => {
                setactivity(response);
            })
    }

    const startFetchProcess = () => {
        updateData();
        const INTERVAL_ID = setInterval(updateData, updatingInterval);
        return INTERVAL_ID;
    }

    useEffect(() => {
        const INTERVAL_ID = startFetchProcess();
        return function () {
            clearInterval(INTERVAL_ID);
        }
    }, [])

    return (
            <Container className="welcome-stats">
                <div className="welcome-card">
                    <h1>Aujourd'hui </h1>
                    <Row>
                        <Col>
                            <ActivitiesCard 
                            activityName='Casques utilisés'
                            activityData={activity.dailyActiveHeadset !==null && activity.dailyActiveHeadset !==undefined ? activity.dailyActiveHeadset : '-'}
                            key='dailyActiveHeadset'
                        />
                    </Col>

                    <Col>
                        <ActivitiesCard
                            activityName='XP vues casques'
                            activityData={activity?.dailyVideosViewed?.headsetViews !==null && activity?.dailyVideosViewed?.headsetViews !== undefined ?
                                activity.dailyVideosViewed.headsetViews
                                : '-'}
                            key='dailyVideosHeadsetViewed'
                        />
                        </Col>

                        <Col>
                        <ActivitiesCard
                            activityName='XP vues webapp'
                            activityData={activity?.dailyVideosViewed?.webapp2Views !==null && activity?.dailyVideosViewed?.webapp2Views !== undefined ? 
                                activity.dailyVideosViewed.webapp2Views
                                : '-'}
                            key='dailyVideosWebapp2Viewed'
                        />
                        </Col>

                        <Col>
                            <ActivitiesCard 
                            activityName='Stories vues'
                            activityData={activity.dailyStoriesViewed !==null && activity?.dailyStoriesViewed !== undefined ? 
                                activity.dailyStoriesViewed 
                                : '-'}
                            key='dailyStoriesViewed'
                            lastActivitiesData={true}
                        />
                        </Col>
                    </Row>
                </div>
                <div className="welcome-card">
                    <h1>Sur 7 jours </h1>

                    <Row>
                        <Col>
                        <ActivitiesCard
                            activityName='Casques utilisés'
                            activityData={activity.weeklyActiveHeadset !==null && activity.weeklyActiveHeadset !==undefined ? activity.weeklyActiveHeadset : '-'}
                            key='weeklyActiveHeadset'
                            />
                        </Col>

                        <Col>
                            <ActivitiesCard 
                            activityName='XP vues casques'
                            activityData={activity?.weeklyVideosViewed?.headsetViews !==null && activity?.weeklyVideosViewed?.headsetViews !== undefined ?
                                activity.weeklyVideosViewed.headsetViews
                                : '-'}
                            key='weeklyVideosHeadsetViewed'
                        />
                    </Col>

                    <Col>
                        <ActivitiesCard
                            activityName='XP vues webapp'
                            activityData={activity?.weeklyVideosViewed?.webapp2Views !==null && activity?.weeklyVideosViewed?.webapp2Views !== undefined ? 
                                activity.weeklyVideosViewed.webapp2Views
                                : '-'}
                            key='weeklyVideosWebapp2Viewed'
                        />
                    </Col>

                    <Col>
                        <ActivitiesCard
                            activityName='Stories vues'
                            activityData={activity.weeklyStoriesViewed !==null && activity?.weeklyStoriesViewed !== undefined ? 
                                activity.weeklyStoriesViewed 
                                : '-'}
                            key='weeklyStoriesViewed'
                            lastActivitiesData={true}
                        />
                        </Col>
                    </Row>
                </div>
                <div className="welcome-card">
                    <h1>Sur 30 jours</h1>

                    <Row>
                        <Col>
                            <ActivitiesCard 
                            activityName='Casques utilisés'
                            activityData={activity.monthlyActiveHeadset !== null && activity.monthlyActiveHeadset !== undefined
                                ? activity.monthlyActiveHeadset
                                : '-'}
                            key='monthlyActiveHeadset'
                        />
                    </Col>

                    <Col>
                        <ActivitiesCard
                            activityName='XP vues casques'
                            activityData={activity.monthlyVideosViewed?.headsetViews !== null && activity.monthlyVideosViewed?.headsetViews !== undefined
                                ? activity.monthlyVideosViewed?.headsetViews
                                : '-'}
                            key='monthlyVideosHeadsetViewed'
                        />
                        </Col>

                        <Col>
                        <ActivitiesCard
                            activityName='XP vues webapp'
                            activityData={activity.monthlyVideosViewed?.webapp2Views !== null && activity.monthlyVideosViewed?.webapp2Views !== undefined
                                ? activity.monthlyVideosViewed?.webapp2Views
                                : '-'}
                            key='monthlyVideosWebapp2Viewed'
                        />
                        </Col>

                        <Col>
                            <ActivitiesCard 
                            activityName='Stories vues'
                            activityData={activity.monthlyStoriesViewed !== null && activity.monthlyStoriesViewed !== undefined
                                ? activity.monthlyStoriesViewed
                                : '-'}
                            key='monthlyStoriesViewed'
                            lastActivitiesData={true}
                        />
                        </Col>
                    </Row>
                </div>
            </Container>
    )
}

export default ActivitiesPanel;